module.exports = __webpack_public_path__ + "04895c45aef659ccdd1c340f5bf0948a.svg";